import React from "react";
import commonCss from "./css/SurveyStyle.scss";
import css from "./css/StudentSurveyConfirmSetUp.scss";
import {pressedEnterOrSpace} from "utils/accessibility";
import PropTypes from "prop-types";
import StyledButton from "common/StyledButton";
import {isEmptyString} from "utils/text";
import Icon from "SF/MaterialIcon";
import classnames from "classnames";
import {getWord} from "utils/tenant";
import {formattedDateTime, formValidationErrorState, formHasError} from "./templateValidation"

function StudentSurveyConfirmSetUp({formData, cohortTemplates, goToTab}) {

    const surveyConfirmPageData = formValidationErrorState(formData)
    const formError = formHasError(formData) ? `Complete required fields to schedule ${getWord('studentSurvey', false)}.` : ''

    const findCohortNamesByIds = () => {
        if (!formData.audience.cohortIds) return
        const selectedIds = formData.audience.cohortIds
        return cohortTemplates.filter(cohortTemplate => selectedIds.includes(cohortTemplate.id)).map(templates => templates.name).join(', ')
    }

    const getAudience = () => {
        if (formData.audience.allStudents) return 'All Students'
        return <><span className={css['field-name']}>Cohorts:</span> {findCohortNamesByIds()}</>
    }

    const getCloseDateTime = () => {
        if (!formData.timing.closeDate)
            return 'None selected. Students can make updates indefinitely.';
        return formattedDateTime(formData.timing, "close")
    }

    return (
        <>
            <h2 className={commonCss['header-second-level']}>Confirm & Schedule</h2>
            {formError &&
                <div className={css['form-error']}>
                    <Icon aria-hidden="true" icon="error"/>
                    {formError}
                </div>}
            <table className={css['review-data']}>
                <tbody>
                <tr>
                    <td>
                        {surveyConfirmPageData.title.error && <Icon className={css['error-icon']} aria-hidden="true" icon="error"/>}
                        <a className={classnames(commonCss['header-third-level'], css['link-text'])}
                           href="#"
                           onClick={() => goToTab('Properties')}
                           onKeyDown={(e) => { if (pressedEnterOrSpace(e)) goToTab('Properties')} }>
                           Properties
                        </a>
                    </td>
                </tr>
                <tr>
                    <td className={css['field-name']}>Title</td>
                    <td className={classnames(commonCss['instructional-text'], {[css.error]: !!surveyConfirmPageData.title.error})}>
                        {surveyConfirmPageData.title.error ? surveyConfirmPageData.title.error : surveyConfirmPageData.title.value}
                    </td>
                </tr>
                <tr>
                    <td className={css['field-name']}>Description</td>
                    <td>{isEmptyString(formData.description) ? 'N/A' : formData.description}</td>
                </tr>
                <tr><td colSpan={2}><hr className={css['horizontal-line']}/></td></tr>
                <tr>
                    <td>
                        {surveyConfirmPageData.build.error && <Icon className={css['error-icon']} aria-hidden="true" icon="error"/>}
                        <a className={classnames(commonCss['header-third-level'], css['link-text'])}
                            href="#"
                            onClick={() => goToTab('Build')}
                            onKeyDown={(e) => { if (pressedEnterOrSpace(e)) goToTab('Build')} }>
                            Build
                        </a>
                    </td>
                </tr>
                <tr>
                    <td className={css['field-name']}>Survey Content</td>
                    <td className={classnames({[css.error]: !!surveyConfirmPageData.build.error})}>
                        {surveyConfirmPageData.build.error ?
                            surveyConfirmPageData.build.error :
                            <StyledButton className={css['button']} inverted onClick={() => goToTab('Build')}>
                                Preview Survey
                            </StyledButton>}
                    </td>
                </tr>
                <tr><td colSpan={2}><hr className={css['horizontal-line']}/></td></tr>
                <tr>
                    <td>
                        {surveyConfirmPageData.audience.error && <Icon className={css['error-icon']} aria-hidden="true" icon="error"/>}
                        <a className={classnames(commonCss['header-third-level'], css['link-text'])}
                            href="#"
                            onClick={() => goToTab('Audience')}
                            onKeyDown={(e) => { if (pressedEnterOrSpace(e)) goToTab('Audience')} }>
                            Audience
                        </a>
                    </td>
                </tr>
                <tr>
                    <td className={css['field-name']}>Criteria</td>
                    <td className={classnames(commonCss['instructional-text'], {[css.error]: !!surveyConfirmPageData.audience.error})}>
                        {surveyConfirmPageData.audience.error ? surveyConfirmPageData.audience.error : getAudience()}
                    </td>
                </tr>
                <tr>
                    <td colSpan={2}><hr className={css['horizontal-line']}/></td>
                </tr>
                <tr>
                    <td>
                        {surveyConfirmPageData.openDateTime.error && <Icon className={css['error-icon']} aria-hidden="true" icon="error"/>}
                        <a className={classnames(commonCss['header-third-level'], css['link-text'])}
                            href="#"
                            onClick={() => goToTab('Timing')}
                            onKeyDown={(e) => { if (pressedEnterOrSpace(e)) goToTab('Timing')} }>
                            Timing
                        </a>
                    </td>
                </tr>
                <tr>
                    <td className={css['field-name']}>Timeframe</td>
                    <td>
                        <div className={css['nested-cell']}>
                            <div className={css['row-wise']}>
                                <div className={css['field-name']}>Open: </div>
                                <div className={classnames(commonCss['instructional-text'], css['left-spaced'], {[css.error]: !!surveyConfirmPageData.openDateTime.error})}>
                                    {surveyConfirmPageData.openDateTime.error ? surveyConfirmPageData.openDateTime.error : surveyConfirmPageData.openDateTime.value}
                                </div>
                            </div>
                            <div className={css['row-wise']}>
                                <div className={css['field-name']}>Closed: </div>
                                <div className={classnames(commonCss['instructional-text'], css['left-spaced'])}>{getCloseDateTime()}</div>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </>
    )
}

export default StudentSurveyConfirmSetUp;

StudentSurveyConfirmSetUp.propTypes = {
    cohortTemplates: PropTypes.array,
    formData: PropTypes.object,
    goToTab: PropTypes.func.isRequired
};
